import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-lymphatic-walking-pr',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		// The loader screen is identical to the base lymphatic funnel's in the design
		// (Figma `landing` 23768:72364 renders the same `main_walking.lymphatic.loader.title`),
		// so it is reused rather than duplicated — the same call `female-printable-walking`
		// makes with `loader-walking-f`. Only the age picker gains the printable banner.
		ids: ['loader-lymphatic-walking-f', 'age-lymphatic-walking-f-pr'],
		route: {
			path: '/lymphatic-walking-f-pr',
			name: 'lymphatic-walking-f-pr-funnel',
		},
	},
	funnel: {
		id: 'ob-female-activity-lymphatic-walking-pr',
		route: {
			path: '/lymphatic-walking-f-pr/ob/:page(.*)?',
			name: 'activity-female-lymphatic-walking-pr',
		},
		slug: 'activity-female-lymphatic-walking-pr',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		// Single paywall for every country, matching `activity-female-tai-chi-walking-pr` and the
		// base lymphatic funnel as it ships today: non-US traffic gets the US ladder. The regional
		// split (US / EU / ROW) is being introduced for the base funnel by DEV-34967 and would be
		// ported here in a follow-up.
		routeName: 'plan-lymphatic-walking-f-pr',
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
}

export default appAreaConfig
